// Locale registry. CLAUDE.md §13: Arabic is the default locale, RTL.
// Add Khaleeji/Levantine/Egyptian variants here when content tagging lands (CLAUDE.md §3).

export const LOCALES = ['ar', 'en'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'ar';

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (LOCALES as readonly string[]).includes(value);
}

export function isRtlLocale(locale: Locale): boolean {
  return locale === 'ar';
}

export function localeDirection(locale: Locale): 'rtl' | 'ltr' {
  return isRtlLocale(locale) ? 'rtl' : 'ltr';
}
